/**
 * @author tomekbuszewski
 * @since 2019-6-14
 */

import * as React from "react";
import styled, { useTheme } from "styled-components";

import { Heading } from "@ui/Atoms";
import { Caret } from "@ui/Assets/Symbolicons/Caret";
import { rem } from "@ui/helpers";

interface Props {
  className?: string;
  children?: React.ReactNode;
  withCaret?: boolean;
  withoutMarginBottom?: boolean;
}

const MobileSectionTitle = (props: Props) => {
  const theme = useTheme();

  return (
    <StyledHeader
      className={props.className}
      withoutMarginBottom={props.withoutMarginBottom}
    >
      {props.withCaret && (
        <CaretWrapper>
          <Caret size={28} variant="line" color={theme.palette.blue500} />
        </CaretWrapper>
      )}
      <StyledHeading type="h5" styleAs="h6">
        {props.children}
      </StyledHeading>
    </StyledHeader>
  );
};

const StyledHeader = styled.header<{ withoutMarginBottom?: boolean }>`
  display: flex;
  align-items: center;
  margin-bottom: ${props =>
    props.withoutMarginBottom ? "0" : props.theme.margins.base_x4};
  padding: 0 ${props => props.theme.margins.base};
`;

const CaretWrapper = styled.span`
  line-height: ${rem(30)};
  margin-right: ${props => props.theme.margins.base};

  svg {
    transform: rotate(90deg);
  }
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 0;
`;

export { MobileSectionTitle };

MobileSectionTitle.displayName = "MobileSectionTitle";
